<form [formGroup]="form" class="space-y-4 mt-2" (ngSubmit)="save()">
  <p-float-label variant="on">
    <input pInputText formControlName="name" id="companyName" class="w-full" />
    <label for="companyName">Nome Azienda *</label>
  </p-float-label>

  <p-float-label variant="on">
    <input pInputText formControlName="code" id="companyCode" class="w-full" />
    <label for="companyCode">Codice</label>
  </p-float-label>

  <p-float-label variant="on">
    <input pInputText formControlName="vatNumber" id="vatNumber" class="w-full" />
    <label for="vatNumber">Partita IVA</label>
  </p-float-label>

  <div class="flex justify-end gap-2 pt-2">
    <p-button
      label="Cancella"
      icon="pi pi-times-circle"
      size="small"
      severity="secondary"
      type="button"
      (click)="closeDialog()"
    />
    <p-button
      label="Salva"
      icon="pi pi-check-circle"
      size="small"
      type="submit"
      [disabled]="form.invalid"
    />
  </div>
</form>
